import * as angular from 'angular';

// components
import KeychainRemoteModalComponent from './keychainRemoteModal.component';
import PanicPendantModalComponent from './panicPendantModal.component';

export default angular
    .module('fp:activationswizard:activation:modals', [])
    .component('awKeychainRemoteModal', KeychainRemoteModalComponent)
    .component('awPanicPendantModal', PanicPendantModalComponent);